export default "__VITE_ASSET__BiVgLS13__"